/*================================================================
‘Copyright © 2024, Cheers Interactive Pvt Ltd.  All rights reserved.
   File Description :  Access Earthdoc Page
 --------------------------------------------------------------------------------- 
  Creation Details 
  Date Created			: 20/May/2025
  Author						: Satya Prakash Mall
================================================================ 
*/
import React, { useEffect } from "react";

export default () => {
  // ** UTILS **
  const checkEligiblity = async () => {
    const link = document.createElement("a");
    link.href = "https://www.earthdoc.org/";
    link.target = "_self";
    link.rel = "noreferrer"; // Optional but improves enforcement
    link.referrerPolicy = "no-referrer-when-downgrade";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ** EFFECTS **
  useEffect(() => {
    checkEligiblity();
  }, []);

  return (
    <div
      className="gennx-content-wrapper content-wrapper px-3"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", flexDirection: "column" }}
    >
      <h4>Access Earthdoc is now a standalone app.</h4>
      <h6>Please wait while we redirect and log you in.</h6>

      <button onClick={checkEligiblity}>Click here if you are not redirected.</button>
    </div>
  );
};
